// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-bar_wrapper__oKnqD {
  pointer-events: none;

  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: flex-start;

  margin-bottom: auto;
  padding: 10px 20px;

  color: var(--overlayForeground);

  background: var(--controlbarBackgroundColor); /* backwards compatible */

  transition: opacity 0.2s;
}

@supports (color: lab(from red l 1 1% / calc(alpha + 0.1))) {
.top-bar_wrapper__oKnqD {
  background: linear-gradient(
    to top,
    color(from var(--controlbarBackgroundColor) srgb r g b / var(--controlbarBackgroundOpacity)),
    color(from var(--controlbarBackgroundColor) srgb r g b / calc(var(--controlbarBackgroundOpacity) * 0.1 + 0.9))
  );
}
}

.top-bar_wrapper__oKnqD.top-bar_hidden__x5oQk {
    opacity: 0;
  }

.top-bar_wrapper__oKnqD  > * {
    pointer-events: auto;
  }

.top-bar_wrapper__oKnqD .top-bar_logo__9-JLN {
    width: 34px;
    height: 34px;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
  }

.top-bar_wrapper__oKnqD .top-bar_title__B4bHd {
    pointer-events: all;

    overflow: hidden;

    font-size: 12px;
    line-height: 15px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

.top-bar_wrapper__oKnqD .top-bar_downloadSourcesButton__FEK2- {
    margin-left: auto;
  }

@media (prefers-contrast: more), (prefers-reduced-transparency: reduce) {
    .top-bar_wrapper__oKnqD {
      background: var(--controlbarBackgroundColor);
    }
  }

.smallScreen .top-bar_logo__9-JLN {
    width: 24px;
    height: 24px;
  }
`, "",{"version":3,"sources":["webpack://./src/components/top-bar/top-bar.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;;EAEpB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,2BAA2B;;EAE3B,mBAAmB;EACnB,kBAAkB;;EAElB,+BAA+B;;EAE/B,4CAA4C,EAAE,yBAAyB;;EAOvE,wBAAwB;AAqC1B;;AAzDA;AAAA;EAcE;;;;GAIC;AAuCH;AAAA;;AAnCE;IACE,UAAU;EACZ;;AAEA;IACE,oBAAoB;EACtB;;AAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;EACzB;;AAEA;IACE,mBAAmB;;IAEnB,gBAAgB;;IAEhB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;EACrB;;AAEA;IACE,iBAAiB;EACnB;;AAEA;IACE;MACE,4CAA4C;IAC9C;EACF;;AAIA;IACE,WAAW;IACX,YAAY;EACd","sourcesContent":[".wrapper {\n  pointer-events: none;\n\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  justify-content: flex-start;\n\n  margin-bottom: auto;\n  padding: 10px 20px;\n\n  color: var(--overlayForeground);\n\n  background: var(--controlbarBackgroundColor); /* backwards compatible */\n  background: linear-gradient(\n    to top,\n    color(from var(--controlbarBackgroundColor) srgb r g b / var(--controlbarBackgroundOpacity)),\n    color(from var(--controlbarBackgroundColor) srgb r g b / calc(var(--controlbarBackgroundOpacity) * 0.1 + 0.9))\n  );\n\n  transition: opacity 0.2s;\n\n  &.hidden {\n    opacity: 0;\n  }\n\n  > * {\n    pointer-events: auto;\n  }\n\n  .logo {\n    width: 34px;\n    height: 34px;\n    object-fit: contain;\n    object-position: center;\n  }\n\n  .title {\n    pointer-events: all;\n\n    overflow: hidden;\n\n    font-size: 12px;\n    line-height: 15px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .downloadSourcesButton {\n    margin-left: auto;\n  }\n\n  @media (prefers-contrast: more), (prefers-reduced-transparency: reduce) {\n    & {\n      background: var(--controlbarBackgroundColor);\n    }\n  }\n}\n\n:global(.smallScreen) {\n  & .logo {\n    width: 24px;\n    height: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `top-bar_wrapper__oKnqD`,
	"hidden": `top-bar_hidden__x5oQk`,
	"logo": `top-bar_logo__9-JLN`,
	"title": `top-bar_title__B4bHd`,
	"downloadSourcesButton": `top-bar_downloadSourcesButton__FEK2-`
};
module.exports = ___CSS_LOADER_EXPORT___;
